import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReconStage from "./ReconStage.jsx";
import PlanningStage from "./PlanningStage.jsx";
import CampaignStage from "./CampaignStage.jsx";
import DebriefStage from "./DebriefStage.jsx";
import "./WildcatPortfolio.css";

const STAGES = ["intro", "recon", "planning", "campaign", "debrief"];
const STAGE_LABELS = { recon: "Recon", planning: "Plan", campaign: "Expedition", debrief: "Debrief" };

export default function WildcatPortfolio() {
  const navigate = useNavigate();
  const [stage, setStage] = useState("intro");
  const [reconResult, setReconResult] = useState(null);
  const [plan, setPlan] = useState(null);
  const [campaignResult, setCampaignResult] = useState(null);

  const restart = () => {
    setReconResult(null);
    setPlan(null);
    setCampaignResult(null);
    setStage("intro");
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-8">
      <button onClick={() => navigate("/")} className="btn-ghost mb-6 !text-[8px]">
        ◀ BACK TO LEVELS
      </button>

      <div className="panel relative overflow-hidden p-6">
        <div className="mb-6">
          <p className="label-pixel text-magenta">Level 06</p>
          <h1 className="pixel-heading text-base text-mist sm:text-xl">Wildcat Portfolio</h1>
        </div>

        {stage !== "intro" && (
          <div className="mb-6 flex gap-1.5">
            {["recon", "planning", "campaign", "debrief"].map((s) => {
              const idx = STAGES.indexOf(s);
              const currentIdx = STAGES.indexOf(stage);
              const complete = idx < currentIdx;
              const active = s === stage;
              return (
                <div key={s} className="flex-1">
                  <div
                    className={`h-1.5 w-full border border-black/60 ${
                      complete ? "bg-lime" : active ? "bg-cyan" : "bg-panel2"
                    }`}
                  />
                  <p
                    className={`mt-1 text-center font-display text-[7px] uppercase ${
                      active ? "text-cyan" : complete ? "text-lime" : "text-mist/30"
                    }`}
                  >
                    {STAGE_LABELS[s]}
                  </p>
                </div>
              );
            })}
          </div>
        )}

        <div className="wp-panel-transition" key={stage}>
          {stage === "intro" && (
            <div className="text-center">
              <p className="mb-3 text-sm text-mist/80">
                Real estate, gold, crypto, a business, a collection — every one of these can
                build wealth outside the stock market. Every one of them also demands its own
                kind of patience, and none of them belong in your plan until the fundamentals
                already are.
              </p>
              <p className="mb-6 text-xs text-mist/50">
                Three phases: scout the frontier, clear the prerequisites and build a small
                alternative sleeve, then live through a year of the temptations that come with it.
              </p>
              <button onClick={() => setStage("recon")} className="btn-cyan">
                ▶ START SCOUTING
              </button>
            </div>
          )}

          {stage === "recon" && (
            <ReconStage
              onComplete={(result) => {
                setReconResult(result);
                setStage("planning");
              }}
            />
          )}

          {stage === "planning" && (
            <PlanningStage
              onDeploy={(deployedPlan) => {
                setPlan(deployedPlan);
                setStage("campaign");
              }}
            />
          )}

          {stage === "campaign" && plan && (
            <CampaignStage
              onComplete={(result) => {
                setCampaignResult(result);
                setStage("debrief");
              }}
            />
          )}

          {stage === "debrief" && reconResult && plan && campaignResult && (
            <DebriefStage
              reconResult={reconResult}
              plan={plan}
              campaignResult={campaignResult}
              onRetry={restart}
            />
          )}
        </div>
      </div>
    </div>
  );
}
